import { Fragment, useEffect } from "react"
import { useState } from "react";
import { Autocomplete, TextField, Button, Stack } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';

import useFetch from "../../../hooks/useFetch";
import { useForm } from "../../../hooks/useForm";
import { urlGetByClientIdWorks } from '../../../helpers';
import { FetchCertificationAddress } from "./FetchCertificationAddress";

export const ChooseEstimate = ({ client, dataClient, setHiddenComponent, hiddenComponent, setProducts, setIds, setRents }) => {

    const [showForm, setShowForm] = useState(false);
    const [hideButton, setHideButton] = useState(true);
    const [textButton, setTextButton] = useState('Certificar');
    const id = dataClient?.find((cl) => cl.name === client).id;

    const { data, loading } = useFetch(urlGetByClientIdWorks + id);

    const [formValues, handleInputChange] = useForm({
        addresWork: ''
    });

    const { addresWork } = formValues;

    const handleClick = (e) => {
        e.preventDefault();
        setHiddenComponent(!hiddenComponent)
        setTextButton((textButton === 'Certificar') ? 'Cambiar certificación' : 'Certificar')
        setShowForm(!showForm)
    }

    useEffect(() => {
        if (addresWork) {
            setHideButton(false)
        }
    }, [addresWork])

    return (
        <Fragment>
            {loading
                ? <CircularProgress />
                : <Fragment>
                    <Autocomplete
                        disabled={hiddenComponent}
                        disablePortal
                        options={data?.map((e) => e.addressWork) || []}
                        sx={{ width: 300 }}
                        size='small'
                        value={addresWork || null}
                        onChange={(event, newValue) => {
                            handleInputChange({ target: { name: 'addresWork', value: newValue || '' } });
                        }}
                        renderInput={(params) => <TextField {...params} label="Obra" required />}
                    />
                    <Stack width={300}><Button disabled={hideButton} sx={{ minWidth: 150 }} variant="outlined" type='submit' onClick={handleClick}>{textButton}</Button></Stack>
                    {showForm
                        && <Stack width='100%' alignItems='center' mt={1}>
                            <FetchCertificationAddress setRents={setRents} setIds={setIds} setProducts={setProducts} addresWork={addresWork} data={data} />
                        </Stack>}

                </Fragment>
            }
        </Fragment>
    )
}